import Intervals from '../../../base/errors/airdome/Intervals';

const intervals: Intervals = {
  GeneralError: 'Při editaci haly se vyskytla chyba.'
};

export default intervals;
